import './index.scss';

import 'components/modals/basic_modal';
import ModalManager from 'utils/modal_manager';
import {handleApiError} from 'utils/api_error_handler';

class QuestionNotesTab {
  constructor($context) {
    vendorManager.ensure('quill', () => {
      this.$context = $context;
      this.$questionAnnotationArea = false;
      this.instantiateQuill();
      this.bind();
    });
  }

  instantiateQuill() {
    const $editor = $('#annotation-target', this.$context);

    // if quill was already started here we can skip the init function
    if (!$editor.length || $editor.hasClass('ql-container')) return;

    this.editor = new Quill($editor.get(0), {
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          [{color: [false, 'red', 'green', 'blue']}]
        ]
      },
      placeholder: 'Você não possui anotações',
      theme: 'snow'
    });

    this.$questionAnnotationArea = $('.ql-editor', this.$context);

    this.fillQuillContent();
  }

  fillQuillContent() {
    this.$quillContent = $('.ql-editor', this.$context);
    this.$quillContent.html($('.js-annotation-value', this.$context).val());
  }

  bind() {
    const $createForm = $('.js-create-note-form', this.$context);

    $createForm
      .ajaxForm(false)
      .lazyReady()
      .on('submit', e => {
        e.preventDefault();
        if (this._validateAnnotationArea())
          this.saveNote();
        return false;
      });

    $('.js-delete-note-btn', this.$context).on('click', e => this.deleteNote(e));
  }

  saveNote() {
    this.$questionAnnotationArea = $('.ql-editor', this.$context).html();

    $('.js-annotation-value').val(this.$questionAnnotationArea);
    const $createForm = $('.js-create-note-form', this.$context);
    const data = $createForm.serializeObject();
    const method = $createForm.find('[name="_method"]').length ? 'update' : 'create';

    Thor.Annotation[method](data.annotation.id ? {
      id: data.annotation.id
    } : {}, {
      data: data
    }).then(() => {
      $createForm
        .trigger('ajax:success');

      this.reload();
    }).catch(({response}) => $createForm.trigger('ajax:error', response));
  }

  _validateAnnotationArea() {
    const hasBlankClass = $('.ql-editor', this.$context).hasClass('ql-blank');
    const isWhiteSpace = $('.ql-editor', this.$context).html() === '';

    if (!hasBlankClass && !isWhiteSpace) {
      return true;
    } else {
      toastr.warning('Seu comentário não pode ser vazio.');
      return false;
    }
  }

  deleteNote(e) {
    ModalManager.open('#js-confirm-delete-note-modal', res => {
      const annotationId = $(e.currentTarget).data('annotation-id');

      if (res === true)
        Thor.Annotation.delete({
          id: annotationId
        }, {}).then(() => {
          toastr.success('Anotação excluída com sucesso!');
          this.reload();
        }).catch(({response}) => {
          handleApiError('Ops! Não foi possível excluir sua anotação nesse momento!', response);
        });
    });
  }

  reload() {
    window.QuestionBelt.loadTab(this.$context.parents('.q-question-belt'), 'question_notes', true);
  }
}

(function () {
  'use strict';

  $(document).on('componentLoaded:questions/question_notes', (e, data) => {
    new QuestionNotesTab(data.context);
  });
})(jQuery);
